import { render, staticRenderFns } from "./TimelineSide.vue?vue&type=template&id=610e0a8e&scoped=true"
import script from "./TimelineSide.vue?vue&type=script&lang=js"
export * from "./TimelineSide.vue?vue&type=script&lang=js"
import style0 from "./TimelineSide.vue?vue&type=style&index=0&id=610e0a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e0a8e",
  null
  
)

export default component.exports